import type { ReactNode } from "react";
import { LeftChevron } from "lola-framework-ui-test";

export interface NavbarBackChevronProps {
  /** When false, no chevron overlay (e.g. Transactions with noBackButton). */
  visible?: boolean;
  /** Same handler as Navbar onBackClick — chevron covers the default back hit target. */
  onBackClick?: (id?: number) => void;
  children: ReactNode;
}

/**
 * Wraps a kit Navbar and overlays LeftChevron on the default back icon
 * (same chip pattern as ReceiptSummaryPage close).
 */
export const NavbarBackChevron = ({
  visible = true,
  onBackClick,
  children,
}: NavbarBackChevronProps) => (
  <section className="navbar-back-wrapper">
    {children}
    {visible && (
      <div className="lola-navbar navbar-back-chevron-slot">
        <LeftChevron
          size={26}
          className="lola-navbar--back-icon"
          aria-label="Back"
          onClick={() => onBackClick?.(-1)}
        />
      </div>
    )}
  </section>
);
